import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import OfficeUseApply from '@/types/table/officeUseApply';
import { OfficeSupplyData } from '@/api/generated/officeSupplyController';
import { API_CONTEXT } from '../config';
import { OfficeSupplyOrderData } from '@/api/generated/officeSupplyOrderController';

const { buildGetUrl } = useUrlBuilder();

export interface OfficeUseApplyData extends OfficeUseApply {
  officeSupplyList?: OfficeSupplyData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class OfficeUseApplyController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<OfficeUseApplyData>>(API_CONTEXT + '/office/officeUseApply/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeUseApplyData>(API_CONTEXT + '/office/officeUseApply/view', params, httpOptions);
  }
  static viewFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<OfficeSupplyOrderData>(API_CONTEXT + '/office/officeUseApply/viewFlow', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/office/officeUseApply/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/office/officeUseApply/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/office/officeUseApply/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/update', params, httpOptions);
  }
  static outBound(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/outBound', params, httpOptions);
  }
  static useConfirm(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/useConfirm', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/deleteBatch', params, httpOptions);
  }
  static startOnlyOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/startOnly/OfiiceUseApplyFlow', params, httpOptions);
  }
  static startWithBusinessKeyOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/startWithBusinessKey/OfiiceUseApplyFlow', params, httpOptions);
  }
  static startAndTakeUserTaskOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/startAndTakeUserTask/OfiiceUseApplyFlow', params, httpOptions);
  }
  static startAndSaveDraftOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/startAndSaveDraft/OfiiceUseApplyFlow', params, httpOptions);
  }
  static submitUserTaskOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/submitUserTask/OfiiceUseApplyFlow', params, httpOptions);
  }
  static viewTaskBusinessDataOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/office/officeUseApply/viewTaskBusinessData/OfiiceUseApplyFlow', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/office/officeUseApply/viewHistoricTaskBusinessData/OfiiceUseApplyFlow', params, httpOptions);
  }
  static listWorkOrderOfiiceUseApplyFlow(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/officeUseApply/listWorkOrder/OfiiceUseApplyFlow', params, httpOptions);
  }
  static listOfficeUseApplyDetails(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/listOfficeUseApplyDetails', params, httpOptions);
  }
  static dictList(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/office/officeUseApply/statusDictList', params, httpOptions);
  }
}
